import { render, staticRenderFns } from "./chargeCabinet-order-info.vue?vue&type=template&id=6726dd32&scoped=true&"
import script from "./chargeCabinet-order-info.vue?vue&type=script&lang=js&"
export * from "./chargeCabinet-order-info.vue?vue&type=script&lang=js&"
import style0 from "./chargeCabinet-order-info.vue?vue&type=style&index=0&id=6726dd32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6726dd32",
  null
  
)

export default component.exports